import { MouseEvent, ReactNode } from 'react';
import { TypographyVariant, Color, Weight } from 'src/types';
import './typography.scss';

interface Props {
    className?: string;
    component?: string;
    children?: ReactNode;
    /** font-size. */
    variant?: TypographyVariant;
    /** color */
    color?: Color;
    /** font-weight. */
    weight?: Weight;
    dangerouslySetInnerHTML?: {
        __html: string;
    };
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    [key: string]: any;
}

export function Typography({
    component = 'p',
    className = '',
    variant = 'size-16',
    color = 'color-2',
    weight = 'regular',
    children,
    onClick,
    ...props
}: Props): JSX.Element {
    const Component = component === 'span' ? 'span' : 'p';

    const classNames = [
        'typography',
        variant,
        color,
        `weight-${weight}`,
        className,
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <Component {...props} onClick={onClick} className={classNames}>
            {children}
        </Component>
    );
}